"use client";
import { Box, Checkbox, Grid, useMediaQuery } from "@mui/material";
import { FontAwesomeIcon, VeBox, VeTypography } from "../../../mui";
import { Capitalize, cleanString } from "../../../hoc";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import ReferenceDrawer from "./ReferenceDrawer";
import CopySvg from "./CopySvg";
import InfoImg from "./InfoImg";
import { VeTooltip } from "../../VeTooltip/VeTooltip";
import { VeInput } from "../../Input/VeInput";
import { VeTextArea } from "../../TextArea/VeTextArea";
import { VeDatePicker } from "../..";
import SubSectionInputType from "./SubSectionInputType";
export function SubSection({
  data,
  RichText,
  editData,
  assets,
  DynamicImage,
  getFileTypeImage,
  useQueryData,
  useMutation,
  mutateAction,
  toast,
  useSession,
  projectId,
  updateQuestionMetadata,
  questionMetadata,
  timeZoneDateTimeUser,
  edit = true,
  setProjectDetails,
  projectDetails,
  user = false,
}: any) {
  const [open, setOpen] = useState<boolean | string>(false);
  const toggleDrawer = (id: string | boolean) => {
    setOpen(id);
  };
  const getQuestionMetadataById = (id: string) => {
    const obj = questionMetadata?.find((item: any) => item.fieldId === id);
    return obj?.docCount + obj?.referenceLinks?.length
      ? `${obj?.docCount + obj?.referenceLinks?.length}`
      : "";
  };
  // function isNumberString(str: string) {
  //   if (typeof str !== "string") return false;
  //   return /^-?\d+(\.\d+)?$/.test(str.trim());
  // }
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gap={"12px"}
      paddingLeft={"16px"}
      paddingY={"8px"}
      borderLeft={"2px solid #C0B6F7"}
      // marginBottom={"16px"}
    >
      <VeTypography variant="label3StrongerTertiary" letterSpacing={"3%"}>
        {(data?.subsectionLabel)?.toUpperCase()}
      </VeTypography>
      <Box display={"flex"} flexDirection={"column"} gap={"24px"}>
        {data?.fields?.map((item: any) => (
          <Grid container key={item?.fieldId}>
            <Grid item xs={12} lg={12}>
              <Box
                display={"flex"}
                flexDirection={"column"}
                gap={"8px"}
                key={item?.fieldId}
              >
                {item?.fieldType !== "singleCheckbox" && (
                  <Box
                    display={"flex"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                  >
                    <VeTypography variant="label2StrongMain">
                      {item?.index}. {item?.fieldLabel}&nbsp;
                      {item?.metadata?.isRequired && (
                        <VeTypography
                          variant="label2StrongMain"
                          sx={{ color: "#DE1135 !important" }}
                        >
                          *
                        </VeTypography>
                      )}
                    </VeTypography>
                    {item?.metadata?.helptext && (
                      <VeTooltip
                        placement="right"
                        title={
                          <Box
                            display={"flex"}
                            width={"340px"}
                            flexDirection={"column"}
                            padding={"8px"}
                          >
                            <VeTypography
                              variant="label4Main"
                              sx={{
                                color: "white !important",
                                fontSize: "12px",
                                lineHeight: "18px",
                              }}
                            >
                              {item?.metadata?.helptext}
                            </VeTypography>
                          </Box>
                        }
                        arrow
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          zIndex: 500,
                        }}
                        // color="white"
                      >
                        <Box
                          display={"flex"}
                          sx={{ cursor: "help" }}
                          width={"fit-content"}
                          alignItems={"center"}
                          marginLeft={"5px"}
                        >
                          <InfoImg />
                        </Box>
                      </VeTooltip>
                    )}
                  </Box>
                )}
                {/* Render field input based on fieldType */}
                <SubSectionInputType
                  disabled={!edit}
                  editData={editData}
                  data={data}
                  item={item}
                />
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  sx={{
                    cursor: "pointer",
                    // "&:hover": {
                    //   textDecoration: "underline",
                    // },
                  }}
                  onClick={() => edit && toggleDrawer(item?.fieldId)}
                >
                  {/* {edit && (
                    <Box>
                      {DynamicImage(assets?.add, "close", 9, 9)}{" "}
                      <VeTypography
                        variant="label3Brand"
                        className="document_title"
                      >
                        Add Reference
                      </VeTypography>
                    </Box>
                  )} */}
                  {getQuestionMetadataById(item?.fieldId)?.length > 0 && (
                    <VeBox
                      sx={{
                        backgroundColor: "rgba(243, 243, 243, 1)",
                        borderRadius: "2px",
                        padding: "6px 6px",
                        justifyContent: "center",
                        width: "max-content",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        marginLeft: "auto",
                      }}
                    >
                      <CopySvg />
                      <VeTypography variant="label4Tertiary">
                        {getQuestionMetadataById(item?.fieldId)} References
                      </VeTypography>
                    </VeBox>
                  )}
                </Box>
                {open === item?.fieldId && (
                  <ReferenceDrawer
                    open={open === item?.fieldId}
                    user={user}
                    toggleDrawer={toggleDrawer}
                    question={`${item?.index}. ${item?.fieldLabel}`}
                    upload={assets?.["upload"]}
                    DynamicImage={DynamicImage}
                    getFileTypeImage={getFileTypeImage}
                    useSession={useSession}
                    useMutation={useMutation}
                    useQueryData={useQueryData}
                    mutateAction={mutateAction}
                    toast={toast}
                    id={item?.fieldId}
                    projectId={projectId}
                    updateQuestionMetadata={updateQuestionMetadata}
                    timeZoneDateTimeUser={timeZoneDateTimeUser}
                    edit={edit}
                    setProjectDetails={setProjectDetails}
                    projectDetails={projectDetails}
                    assets={assets}
                  />
                )}
              </Box>
            </Grid>
          </Grid>
        ))}
      </Box>
    </Box>
  );
}
